import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, NgZone, HostListener, ViewChild } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ToastsComponent } from './components/toasts.component';
import { AuthService } from './services/auth.service';
import { Tooltip } from 'bootstrap';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterModule, ToastsComponent],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'Festival Bands';
  theme: 'light' | 'dark' = 'light';
  userEmail?: string;
  isAdmin = false;
  userMenuOpen = false;

  @ViewChild('userMenuRef') userMenuRef?: ElementRef<HTMLElement>;

  private sub?: any;
  private tooltipInstances: any[] = [];
  constructor(private router: Router, private auth: AuthService, private elRef: ElementRef<HTMLElement>, private zone: NgZone) {}

  async ngOnInit() {
    const saved = localStorage.getItem('fb-theme') as 'light' | 'dark' | null;
    this.setTheme(saved || 'light');
    // Live-Updates auf An-/Abmeldung
    this.sub = this.auth.userChanges.subscribe(async u => {
      this.userEmail = u?.email || undefined;
      this.isAdmin = u ? await this.auth.isAdmin() : false;
      this.scheduleInitTooltips();
    });
    // Initialen Zustand pushen
    await this.auth.refreshUserState();
  }

  ngAfterViewInit() {
    this.scheduleInitTooltips();
  }

  setTheme(t: 'light' | 'dark') {
    this.theme = t;
    document.documentElement.setAttribute('data-bs-theme', t);
    localStorage.setItem('fb-theme', t);
    this.scheduleInitTooltips();
  }

  toggleTheme() {
    this.setTheme(this.theme === 'light' ? 'dark' : 'light');
  }

  async logout() {
    await this.auth.signOut();
    this.userEmail = undefined;
    this.isAdmin = false;
    this.router.navigateByUrl('/');
  }

  ngOnDestroy() {
    if (this.sub && typeof this.sub.unsubscribe === 'function') this.sub.unsubscribe();
    this.destroyTooltips();
  }

  private scheduleInitTooltips() {
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        this.destroyTooltips();
        const host = this.elRef.nativeElement;
        const nodes = host.querySelectorAll('[data-bs-toggle="tooltip"][title]');
        nodes.forEach((node) => {
          const el = node as HTMLElement;
          const title = el.getAttribute('title');
          if (title && title.trim().length > 0) {
            const t = new Tooltip(el, { container: 'body', placement: 'bottom', trigger: 'hover focus' });
            this.tooltipInstances.push(t);
          }
        });
      });
    });
  }

  private destroyTooltips() {
    for (const t of this.tooltipInstances) {
      try { t.dispose(); } catch {}
    }
    this.tooltipInstances = [];
  }

  toggleUserMenu() {
    this.userMenuOpen = !this.userMenuOpen;
  }

  closeUserMenu() {
    this.userMenuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(ev: MouseEvent) {
    if (!this.userMenuOpen) return;
    const host = this.userMenuRef?.nativeElement;
    if (host && !host.contains(ev.target as Node)) {
      this.userMenuOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.userMenuOpen = false;
  }
}
